import Register from "../components/Register";
import Index from "../components/Resume/index";
import Rate from "../components/Rate";
import CMExists from "../components/CMExists";
import ThankYou from "../components/ThankYou";

export const ROUTES = {
  NONE: { name: "none", component: () => {}, hidden: true },
  REGISTER: { name: "register", component: Register, hidden: false },
  RESUME: { name: "resume", component: Index, hidden: false },
  RATE: { name: "rate", component: Rate, hidden: false },
  CM_EXISTS: { name: "cm_exists", component: CMExists, hidden: true },
  THANK_YOU: { name: "thank_you", component: ThankYou, hidden: true }
};

export const routes = [
  ROUTES.REGISTER,
  ROUTES.RESUME,
  ROUTES.RATE,
  ROUTES.CM_EXISTS,
  ROUTES.THANK_YOU
];
